import React from "react"
import "./styles.css"

const SignatureComponent = (props) => {
    return (
        <footer className="signature">
            <span>Developed by Wan</span>
            <span>2020 - Version 1.0</span>
        </footer>
    )
}

export default SignatureComponent
